<template>
  <div>
    <span
      v-for="category in categories"
      :key="category.id"
      v-on:click="move(category.slug)"
      :class="isActive(category.slug) ? 'active category' : 'category'"
    >
      {{ category.name }}
    </span>
  </div>
</template>

<script>
  const querystring = require('querystring')

  export default {
    props: [
        'categories'
    ],

    data () {
      return {
        searchInitial: '',
        current: '',
        target:''
      }
    },

    methods: {
      isActive (slug) {
        if (slug === this.current) {
          return true;
        }

        return false;
      },

      move(slug) {
        if (this.isActive(slug)) {
          var url = '/fintechs';

          if (this.searchInitial) {
            url = url + '?initial=' + this.searchInitial;
          }
        } else {
          var url = '/fintechs?category=' + slug;

          if (slug !== 'fintech_info' && this.searchInitial) {
            url = url + '&initial=' + this.searchInitial;
          }
        }

        location.href = url;
        return false;

      }
    },

    mounted () {
      if (location.search) {
        const search = location.search.replace('?', '')
        this.current = querystring.parse(search).category
        this.searchInitial = querystring.parse(search).initial

        if (!this.current) {
          this.current = 'all'
        }
      } else {
        this.current = 'all'
      }
    }
  }
</script>

<style lang="scss">
  @import '../../sass/variables';

  .category {
    color: white !important;
    cursor: pointer;
    margin-right: 5px;
    padding: 5px 15px;
    background: cBaseDk(40);
    margin-bottom: 5px;
    font-family: $font-family-sans-serif;
    display: inline-block;
    text-align: center;
    &.active{
      background: $cKey;
    }
  }

  // small
  @media screen and (max-width:750px){
    .category {
      font-size: 13px;
      padding: 5px 10px;
    }
  }
</style>